import {useSelector} from 'react-redux'
import {getAnchorCountryPlaceId} from 'modules/sapiSearch/selectors'
import {COUNTRY_TOP_HOTELS_LIMIT} from 'modules/seoApi/selectors'
import {useRouter} from 'next/router'

import {LinksTabs} from './LinksTabs'
import {usePlaceTopHotelsTab} from './useLinksTabs'

/**
 * Top hotels block of the SEO SRP. The place comes from the URL and the
 * country from the search results anchor.
 */
export const SrpTopHotelsLinks = () => {
  const {query} = useRouter()
  const placeId = typeof query.placeId === 'string' ? query.placeId : undefined
  const countryPlaceId = useSelector(getAnchorCountryPlaceId)

  const placeTab = usePlaceTopHotelsTab(placeId)
  const countryTab = usePlaceTopHotelsTab(countryPlaceId, {
    excludedLinks: placeTab?.links,
    limit: COUNTRY_TOP_HOTELS_LIMIT,
    skip: countryPlaceId === placeId // A country SRP is its own country and gets one tab
  })

  return <LinksTabs dataId="topHotelsLinks" tabs={[placeTab, countryTab]} />
}
